/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaInputDatePicker/view.blocks to change it.
import FloatingPortal from 'DesignSystem/FloatingPortal/react'
import React from 'react'
import TysiaDatePicker from 'DesignSystem/TysiaDatePicker/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaInputDatePicker({
  children,
  viewPath = "/DesignSystem/TysiaInput/TysiaInputDatePicker",
  left,
  top,
  innerRef,
  onChange,
  value,
  disableFuture,
  dateFuture,
  disablePast,
  datePast,
  yearPicker,
  yearPastFrom,
  yearTo
  
}) {
  return (<React.Fragment
>
<FloatingPortal
  viewPath={`${viewPath}/FloatingPortal`}
>
{childProps => (
<div
  data-testid="TysiaInputDatePicker.Vertical"
  data-view-path={viewPath}
 ref={innerRef}
 style={{'--l-1-Z1NnCnK': typeof left === 'number' ? `${left}px` : left,'--t-2-Z1NnCnK': typeof top === 'number' ? `${top}px` : top}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaDatePicker
  viewPath={`${viewPath}/TysiaDatePicker`}
 onChange={onChange}
 value={value}
 disableFuture={disableFuture}
 dateFuture={dateFuture}
 disablePast={disablePast}
 datePast={datePast}
 yearPicker={yearPicker}
 yearPastFrom={yearPastFrom}
 yearTo={yearTo}
/>
</div>
)}
</FloatingPortal>
{children}
</React.Fragment>)
}